import "htmx.org";
import { ComboBox } from "./components/combo-box";
import { DevReload } from "./components/dev-reload";
import { DirectQuote } from "./components/direct-quote";
import { GenKey } from "./components/gen-key";
import { GeoLocator } from "./components/geo-locator";
import { ImageField } from "./components/image-field";
import { LiveChat } from "./components/live-chat";
import { MeasureRows } from "./components/measure-rows";
import { MultiCombo } from "./components/multi-combo";
import { PhotoPicker } from "./components/photo-picker";
import { RvModal } from "./components/rv-modal";
import { mountStaticMaps } from "./components/static-map";
import { UnitSelect } from "./components/unit-select";
import { VoiceInput } from "./components/voice-input";

const components = {
  "combo-box": ComboBox,
  "dev-reload": DevReload,
  "direct-quote": DirectQuote,
  "gen-key": GenKey,
  "geo-locator": GeoLocator,
  "image-field": ImageField,
  "live-chat": LiveChat,
  "measure-rows": MeasureRows,
  "multi-combo": MultiCombo,
  "photo-picker": PhotoPicker,
  "rv-modal": RvModal,
  "unit-select": UnitSelect,
  "voice-input": VoiceInput,
};

for (const [tag, ComponentClass] of Object.entries(components)) {
  if (!customElements.get(tag)) {
    customElements.define(tag, ComponentClass);
  }
}

// Collapsible staff sidebar: the topbar toggle button ([data-nav-toggle]) folds
// the sidebar to an icon rail. State is persisted so it sticks across pages, and
// applied before paint by an inline script in the panel <head>. Event delegation
// keeps it working after HTMX swaps.
document.addEventListener("click", (event) => {
  const target = event.target as HTMLElement | null;
  if (!target?.closest("[data-nav-toggle]")) return;
  const collapsed = document.documentElement.classList.toggle("nav-collapsed");
  try {
    localStorage.setItem("rv-nav-collapsed", collapsed ? "1" : "0");
  } catch (e) {
    /* localStorage unavailable (private mode): toggle still works this session */
  }
});

// "Limpiar": clears the field named by data-clear-for. Delegated so it survives HTMX swaps.
document.addEventListener("click", (event) => {
  const button = (event.target as HTMLElement | null)?.closest<HTMLElement>("[data-clear-for]");
  if (!button) return;
  const id = button.dataset["clearFor"];
  const form = button.closest("form") ?? document;
  const field = form.querySelector<HTMLTextAreaElement | HTMLInputElement>(`#${id}`);
  if (!field) return;
  field.value = "";
  field.dispatchEvent(new Event("input", { bubbles: true }));
  field.focus();
});

// Read-only maps (the job's location on a lead). Mounted on load and after every
// HTMX swap, since the lead body is swapped in place on triage.
mountStaticMaps();
document.addEventListener("htmx:after:settle", (event) => {
  const target = (event as CustomEvent).detail?.ctx?.target;
  mountStaticMaps(target instanceof Element ? target : document);
});
